import MapService from './map';
import { Propriedade } from '../@types';
import isNonNullable from '../utils/is-non-nullable';
import aqilaApi from './aqila-api';

class Propriedades {
  private readonly endpoint = 'v1/propriedades';

  private parser = (propriedade: Propriedade) => {
    const glebas = propriedade.glebas?.map((gleba) => {
      const coordenadas = gleba.coordinates
        ?.map((coordinate) => MapService.closePolygon(coordinate))
        .filter(isNonNullable);

      return { ...gleba, coordinates: coordenadas || [] };
    });

    return {
      ...propriedade,
      glebas,
      // api envia a areaTotal como string
      areaTotal: +propriedade.areaTotal,
    };
  };

  async list() {
    const { data } = await aqilaApi.get<Propriedade[]>(this.endpoint);

    return data.map(this.parser);
  }

  async find(id: string) {
    const { data } = await aqilaApi.get<Propriedade>(`${this.endpoint}/${id}`);

    return data;
  }

  async all() {
    const { data } = await aqilaApi.get<Propriedade[]>(`${this.endpoint}/all`);

    return data.map(this.parser);
  }
}

export default new Propriedades();
